import * as React from 'react';

// Material-UI
import BlockIcon from '@mui/icons-material/Block';
import { amber, blueGrey, green, red } from '@mui/material/colors';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Grid from '@mui/material/Grid';
import PanToolIcon from '@mui/icons-material/PanTool';
import PendingIcon from '@mui/icons-material/Pending';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

// Styles
import { useTheme } from '@mui/material/styles';

import {
  RequestMember
} from '../../models';

import {
  SignupStatusID
} from '../../global';

// UTC to local date formatting hooks
import { useDates } from '../../hooks/UseDates';

interface RequestSummaryMembersProps {
  members: Array<RequestMember>;
}

const RequestSummaryMembers: React.FC<RequestSummaryMembersProps> = (props) => {

  const { dateStringToLocalDateFormatted } = useDates();

  // #region Styles

  const theme = useTheme();
  const styles = {
    confirmed: {
      color: green[500]
    },
    deined: {
      color: red[500]
    },
    membersContainer: {
      margin: theme.spacing(1, 0, 1, 0)
    },
    pending: {
      color: blueGrey[500]
    },
    waitlist: {
      color: amber[500]
    }
  };

  // #endregion

  // #region Methods

  /*
* Render the request status icon
*/
  const renderStatus = (statusID: number, status: string) => {

    switch (statusID) {
      case SignupStatusID.Requested:
        return (
          <Tooltip title={status} arrow>
            <PendingIcon fontSize="medium" sx={styles.pending} />
          </Tooltip>
        )
      case SignupStatusID.Confirmed:
        return (
          <Tooltip title={status} arrow>
            <CheckCircleIcon fontSize="medium" sx={styles.confirmed} />
          </Tooltip>
        )
      case SignupStatusID.Waitlist:
        return (
          <Tooltip title={status} arrow>
            <PanToolIcon fontSize="medium" sx={styles.waitlist} />
          </Tooltip>
        )
      case SignupStatusID.Denied:
        return (
          <Tooltip title={status} arrow>
            <BlockIcon fontSize="medium" sx={styles.deined} />
          </Tooltip>
        )
      default:
        return (<span />)
    }

  }

  /*
   * Render members 
   */
  const renderMembers = () => {

    let ms: Array<React.JSX.Element> = [];

    props.members.forEach(m => {
      ms.push(
        <Grid container size={12} spacing={1} alignItems="center">
          <Grid size={1}>
            {renderStatus(m.statusID, m.status)}
          </Grid>
          <Grid size={6}>
            <Typography variant="body2">{m.lastName || ''}, {m.firstName || ''} ({m.gender})-{m.memberStatus}</Typography>
          </Grid>
          <Grid size={5}>
            <Typography variant="body2">{dateStringToLocalDateFormatted(m.arrivalDate, 'EEEEEE MM/dd')} - {dateStringToLocalDateFormatted(m.departureDate, 'EEEEEE MM/dd')} ({m.nights} nights)</Typography>
          </Grid>
        </Grid>
      );
    });

    return ms;
  }

  // #endregion

  return (
    <Grid container size={12} sx={styles.membersContainer}>
      <Grid container size={12}>
        <Typography variant="button">Members</Typography>
      </Grid>
      <Grid container size={12}>
        {renderMembers()}
      </Grid>
    </Grid>
  );

}

export default RequestSummaryMembers;